import { mapGoalDtoToForm } from "web_myplann/Goals/Mappers/mapGoalDtoToForm";
import { mapGoalFormToUpdateRequest } from "web_myplann/Goals/Mappers/mapGoalFormToUpdateRequest";
import type {
	GoalDetailResponseDTO,
	UpdateGoalRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const mapGoalOwnFundsToUpdateRequest = (
	dto: GoalDetailResponseDTO,
	ownFunds: number,
): UpdateGoalRequestDTO | null => {
	const { category, dueDate, totalValue, ...rest } = mapGoalDtoToForm(dto);

	if (!category || !dueDate || totalValue == null) return null;

	return mapGoalFormToUpdateRequest({
		...rest,
		name: rest.name ?? "",
		category,
		dueDate,
		totalValue,
		ownFunds,
	});
};
